// extracted by mini-css-extract-plugin
module.exports = {"popoverOverlay":"style_popoverOverlay__BgF_Z","tableHeaderStyle":"style_tableHeaderStyle__5t03V"};